import { object } from "../helpers/object";
import { debug } from "../helpers/debug";
import { services } from "../helpers/service";
import { utils } from "../helpers/utils";
import { dialog } from "./dialog";
import { gtm } from "./gtm";

class TermsOfUse {

	constructor(module) {
		this.MODULE = module;
		this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
		this.TERMS_OF_USE_SERVICE = false;
	}
	/**
	 * INITIALISATION
	 * @returns 
	 */
	init = () => {
		if (!this.DOM_MODULE.length) return;

    // DEFAULT EVENT
    document.addEventListener('click', this.clickHandler);

		this.getTermsOfUse();
		// this.updateTermsOfuse();
		if (debug.DEBUG) console.log('components/term-of-use.js');
	}

  /**
   * CLICK HANDLER
   * 
   * Gestionnaire des event de la barre de navigation
   * @param {event} event 
   * @returns 
   */
  clickHandler = (event) => {
		if (event.target.matches('.js-term-of-use-submit')) {
			this.updateTermsOfuse();
		}
  }

	parseToken = (token) => {
		try {
			return JSON.parse(atob(token.split('.')[1]));
		} catch (e) {
			return null;
		}
	}

	getContentUrl = function (elem, domEl) {
		var xmlHttp = new XMLHttpRequest();
		if (elem.url) {
			xmlHttp.onreadystatechange = function () {
				if (this.readyState == 4) {
					if (this.status == 200) {
						domEl.innerHTML = this.responseText;
					}
					if (this.status == 404) {
						domEl.innerHTML = "Page not found.";
					}
				}
			}
			xmlHttp.open("GET", elem.url, true);
			xmlHttp.send();
		}
	}


	loginGTM = (parsedToken) => {
		gtm.track({
			'event': 'login',
			'eventCategory': 'Espace connecte',
			'eventAction': 'Login',
			'eventLabel': parsedToken.oid,
		});
	}

	newUserGTM = (parsedToken) => {
		services.use('oauth2IsNew', {user_id: parsedToken.oid}).then((response) => {
			if (response && response.length > 0) {
				gtm.track({
					'event': 'sign_up',
					'eventCategory': 'Espace connecte',
					'eventAction': 'Creation de compte',
					'eventLabel': parsedToken.oid,
				});
			}
		});
	}

	getToken = () => {
		const url = new URL(window.location.href);
		const accessToken = url.searchParams.get("access_token");
		const idToken = url.searchParams.get("id_token");
		if (idToken === null || accessToken === null) return null;
		return {
			accessToken,
			idToken
		}
	}
	getService = () => {
		return this.TERMS_OF_USE_SERVICE;
	}
	/***
	 * Get terms of use after login to CIAM
	 */
	getTermsOfUse = () => {
		const token = this.getToken();
		if (token === null) {
			utils.dispatchEvent('TERMS_OF_USE_SERVICE');
		} else {
			dialog.open('popin-loading');
			services.use('termsofuse', {
					access_token: token.accessToken,
					id_token: token.idToken
				})
				.then((response) => {
					const data = JSON.parse(response);
					if (data.length > 0) {
						let show = false;
						let reload = false;
						data.map((elem) => {
							if (elem.type == "consent" || elem.type == "update") {
								if (elem.document == "TermsOfUse") {
									this.termOfUsePopinContent(elem, 'terms-of-use-url', "ToU");
								} else {
									this.termOfUsePopinContent(elem, 'privacy-policy-url', "Privacy_Policy");
								}
								show = true;
							} else {
								if (elem.reload == true) {
									reload = true;
								}
							}
						})
						if (show) {
							//   document.getElementById("popin-accept-tou").classList.add("active")
							dialog.open('popin-accept-tou');
						} else {
							// utils.dispatchEvent('TERMS_OF_USE_SERVICE');
						}
						if (reload) {
							const urlObj = new URL(window.location.href);
							urlObj.search = '';
							this.loginGTM(this.parseToken(token.idToken));
							window.location.href = urlObj.toString() + '?loaded=auto';
						}
	
					}
				});
		};
	}

	termOfUsePopinContent = (elem, id, type) => { 
		const domEl = document.getElementById(id);
		if (!domEl) return;
		domEl.style.display = "block";
		domEl.setAttribute("data-document-type", type);
		this.getContentUrl(elem, domEl);
	}

	updateTermsOfuse = () => {
		const token = this.getToken();
		if (token === null) return;

		var tou = document.getElementById("terms-of-use-url").getAttribute("data-document-type");
		var pp = document.getElementById("privacy-policy-url").getAttribute("data-document-type");

		if (tou != null || pp != null) { 
			if (tou != null || pp != null) {
				services.use('updatetermsofuse', {
						access_token: token.accessToken,
						documents: [tou, pp],
						id_token: token.idToken
					})
					.then((response) => {
						data = JSON.parse(response);
						if (data.value) {
							dialog.close('popin-accept-tou');
							const urlObj = new URL(window.location.href);
							urlObj.search = '';
							this.newUserGTM(this.parseToken(token.idToken));
							this.loginGTM(this.parseToken(token.idToken));
							window.location.href = urlObj.toString() + '?loaded=auto';
						}
					});
			}
		}
	}
}
export const termOfUse = new TermsOfUse('[data-js-theme="pro"]'); // [data-js-theme="pro"]